/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.MEDICINE_SERVICE_URL) {
      throw new Error('MEDICINE_SERVICE_URL must be set in environment');
    }

    return process.env.MEDICINE_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class PrescriptionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-medicine-dev.sekoia.one", baseUrl);
    }

    getRouteOfAdministrationOptions(): Promise<RouteOfAdministrationOptionResponse[]> {
        let url_ = this.baseUrl + "/api/prescriptions/routeOfAdministrationOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRouteOfAdministrationOptions(_response);
        });
    }

    protected processGetRouteOfAdministrationOptions(response: Response): Promise<RouteOfAdministrationOptionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteOfAdministrationOptionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RouteOfAdministrationOptionResponse[]>(<any>null);
    }

    getDosageUnitOptions(): Promise<DosageUnitOptionResponse[]> {
        let url_ = this.baseUrl + "/api/prescriptions/dosageUnitOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDosageUnitOptions(_response);
        });
    }

    protected processGetDosageUnitOptions(response: Response): Promise<DosageUnitOptionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DosageUnitOptionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DosageUnitOptionResponse[]>(<any>null);
    }

    getPrescriptionAudits(prescriptionId: string): Promise<AuditResponse[]> {
        let url_ = this.baseUrl + "/api/prescriptions/{prescriptionId}/audits";
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionAudits(_response);
        });
    }

    protected processGetPrescriptionAudits(response: Response): Promise<AuditResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditResponse[]>(<any>null);
    }
}

export class PnClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-medicine-dev.sekoia.one", baseUrl);
    }

    createPnPrescription(residentId: string, request: CreatePnPrescriptionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/prescriptions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePnPrescription(_response);
        });
    }

    protected processCreatePnPrescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getPnPrescriptionsForResident(residentId: string, states: PrescriptionState[] | undefined): Promise<PnPrescriptionMetaDataResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/prescriptions?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnPrescriptionsForResident(_response);
        });
    }

    protected processGetPnPrescriptionsForResident(response: Response): Promise<PnPrescriptionMetaDataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PnPrescriptionMetaDataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnPrescriptionMetaDataResponse[]>(<any>null);
    }

    updatePnPrescription(residentId: string, prescriptionId: string, request: UpdatePnPrescriptionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/prescriptions/{prescriptionId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePnPrescription(_response);
        });
    }

    protected processUpdatePnPrescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getPnPrescription(residentId: string, prescriptionId: string): Promise<PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/prescriptions/{prescriptionId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnPrescription(_response);
        });
    }

    protected processGetPnPrescription(response: Response): Promise<PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse>(<any>null);
    }

    updatePnPrescriptionDelegations(residentId: string, prescriptionId: string, request: UpdatePnPrescriptionDelegationsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/prescriptions/{prescriptionId}/delegations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePnPrescriptionDelegations(_response);
        });
    }

    protected processUpdatePnPrescriptionDelegations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getEffectRegistrationOptions(): Promise<EffectRegistrationOptionsResponse> {
        let url_ = this.baseUrl + "/api/pn/EffectRegistrationOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEffectRegistrationOptions(_response);
        });
    }

    protected processGetEffectRegistrationOptions(response: Response): Promise<EffectRegistrationOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EffectRegistrationOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EffectRegistrationOptionsResponse>(<any>null);
    }

    createPnRegistration(residentId: string, request: CreatePnRegistrationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/registrations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePnRegistration(_response);
        });
    }

    protected processCreatePnRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    updatePnRegistration(residentId: string, registrationId: string, request: UpdatePnRegistrationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePnRegistration(_response);
        });
    }

    protected processUpdatePnRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getPnRegistration(residentId: string, registrationId: string): Promise<PnRegistrationResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnRegistration(_response);
        });
    }

    protected processGetPnRegistration(response: Response): Promise<PnRegistrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PnRegistrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnRegistrationResponse>(<any>null);
    }

    getRegistrationsForPrescription(residentId: string, prescriptionId: string, from: moment.Moment | null | undefined): Promise<PnRegistrationMetaDataResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/prescriptions/{prescriptionId}/registrations?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsForPrescription(_response);
        });
    }

    protected processGetRegistrationsForPrescription(response: Response): Promise<PnRegistrationMetaDataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PnRegistrationMetaDataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnRegistrationMetaDataResponse[]>(<any>null);
    }

    updatePnEffectRegistration(residentId: string, registrationId: string, request: UpdatePnEffectRegistrationRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/registrations/{registrationId}/effect";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePnEffectRegistration(_response);
        });
    }

    protected processUpdatePnEffectRegistration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getPnPrescriptions(request: GetPnPrescriptionsRequest): Promise<GetPnPrescriptionsResponse[]> {
        let url_ = this.baseUrl + "/api/pn/prescriptions/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnPrescriptions(_response);
        });
    }

    protected processGetPnPrescriptions(response: Response): Promise<GetPnPrescriptionsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetPnPrescriptionsResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPnPrescriptionsResponse[]>(<any>null);
    }

    getPnRegistrationHistory(residentId: string, registrationId: string): Promise<PnRegistrationHistoryResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/pn/registrations/{registrationId}/history";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnRegistrationHistory(_response);
        });
    }

    protected processGetPnRegistrationHistory(response: Response): Promise<PnRegistrationHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PnRegistrationHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PnRegistrationHistoryResponse>(<any>null);
    }
}

export class NotDispensedClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-medicine-dev.sekoia.one", baseUrl);
    }

    createNotDispensedPrescription(residentId: string, request: CreateNotDispensedPrescriptionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/prescriptions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNotDispensedPrescription(_response);
        });
    }

    protected processCreateNotDispensedPrescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getNotDispensedPrescriptions(residentId: string): Promise<NotDispensedPrescriptionMetaDataResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/prescriptions";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotDispensedPrescriptions(_response);
        });
    }

    protected processGetNotDispensedPrescriptions(response: Response): Promise<NotDispensedPrescriptionMetaDataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotDispensedPrescriptionMetaDataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedPrescriptionMetaDataResponse[]>(<any>null);
    }

    updateNotDispensedPrescription(residentId: string, prescriptionId: string, request: UpdateNotDispensedPrescriptionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/prescriptions/{prescriptionId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNotDispensedPrescription(_response);
        });
    }

    protected processUpdateNotDispensedPrescription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getNotDispensedPrescription(residentId: string, prescriptionId: string): Promise<NotDispensedPrescriptionResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/prescriptions/{prescriptionId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotDispensedPrescription(_response);
        });
    }

    protected processGetNotDispensedPrescription(response: Response): Promise<NotDispensedPrescriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotDispensedPrescriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedPrescriptionResponse>(<any>null);
    }

    getNotDispensedRegistration(residentId: string, registrationId: string): Promise<NotDispensedRegistrationResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotDispensedRegistration(_response);
        });
    }

    protected processGetNotDispensedRegistration(response: Response): Promise<NotDispensedRegistrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotDispensedRegistrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedRegistrationResponse>(<any>null);
    }

    updateNotDispensedRegistration(residentId: string, registrationId: string, request: UpdateNotDispensedRegistrationRequest): Promise<NotDispensedRegistrationResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/registrations/{registrationId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNotDispensedRegistration(_response);
        });
    }

    protected processUpdateNotDispensedRegistration(response: Response): Promise<NotDispensedRegistrationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotDispensedRegistrationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedRegistrationResponse>(<any>null);
    }

    createNotDispensedRegistration(residentId: string, request: CreateNotDispensedRegistrationRequest): Promise<NotDispensedRegistrationCreatedResponse> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/registrations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNotDispensedRegistration(_response);
        });
    }

    protected processCreateNotDispensedRegistration(response: Response): Promise<NotDispensedRegistrationCreatedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotDispensedRegistrationCreatedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedRegistrationCreatedResponse>(<any>null);
    }

    getRegistrationsForPrescription(residentId: string, prescriptionId: string): Promise<NotDispensedRegistrationMetaDataResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/prescriptions/{prescriptionId}/registrations";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionId === undefined || prescriptionId === null)
            throw new Error("The parameter 'prescriptionId' must be defined.");
        url_ = url_.replace("{prescriptionId}", encodeURIComponent("" + prescriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationsForPrescription(_response);
        });
    }

    protected processGetRegistrationsForPrescription(response: Response): Promise<NotDispensedRegistrationMetaDataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotDispensedRegistrationMetaDataResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedRegistrationMetaDataResponse[]>(<any>null);
    }

    getNotDispensedRegistrationHistory(residentId: string, registrationId: string): Promise<NotDispensedRegistrationHistoryResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/notdispensed/registrations/{registrationId}/history";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (registrationId === undefined || registrationId === null)
            throw new Error("The parameter 'registrationId' must be defined.");
        url_ = url_.replace("{registrationId}", encodeURIComponent("" + registrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotDispensedRegistrationHistory(_response);
        });
    }

    protected processGetNotDispensedRegistrationHistory(response: Response): Promise<NotDispensedRegistrationHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotDispensedRegistrationHistoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotDispensedRegistrationHistoryResponse[]>(<any>null);
    }
}

export class MedicineTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-medicine-dev.sekoia.one", baseUrl);
    }

    getMedicineTypeConfigurations(): Promise<MedicineTypeConfigurationResponse[]> {
        let url_ = this.baseUrl + "/api/medicine/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMedicineTypeConfigurations(_response);
        });
    }

    protected processGetMedicineTypeConfigurations(response: Response): Promise<MedicineTypeConfigurationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicineTypeConfigurationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicineTypeConfigurationResponse[]>(<any>null);
    }

    updateMedicineTypeAccessControl(type: string, accessControlRequest: UpdateMedicineTypeAccessControlRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/medicine/types/{type}/accesscontrol";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessControlRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMedicineTypeAccessControl(_response);
        });
    }

    protected processUpdateMedicineTypeAccessControl(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MedicineTaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-medicine-dev.sekoia.one", baseUrl);
    }

    getMedicineTasks(request: GetMedicineTasksRequest): Promise<GetMedicineTasksResponse> {
        let url_ = this.baseUrl + "/api/tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMedicineTasks(_response);
        });
    }

    protected processGetMedicineTasks(response: Response): Promise<GetMedicineTasksResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicineTasksResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMedicineTasksResponse>(<any>null);
    }
}

export class InventoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-medicine-dev.sekoia.one", baseUrl);
    }

    createPrescriptionInventoryItem(residentId: string, request: CreatePrescriptionInventoryItemRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/inventory";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePrescriptionInventoryItem(_response);
        });
    }

    protected processCreatePrescriptionInventoryItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getInventoryForResident(residentId: string): Promise<PrescriptionInventoryItemResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/inventory";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInventoryForResident(_response);
        });
    }

    protected processGetInventoryForResident(response: Response): Promise<PrescriptionInventoryItemResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionInventoryItemResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionInventoryItemResponse[]>(<any>null);
    }

    updatePrescriptionInventoryItemReservedQuantity(residentId: string, prescriptionInventoryItemId: string, reservedQuantity: number): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/inventory/{prescriptionInventoryItemId}/reserved";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionInventoryItemId === undefined || prescriptionInventoryItemId === null)
            throw new Error("The parameter 'prescriptionInventoryItemId' must be defined.");
        url_ = url_.replace("{prescriptionInventoryItemId}", encodeURIComponent("" + prescriptionInventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reservedQuantity);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePrescriptionInventoryItemReservedQuantity(_response);
        });
    }

    protected processUpdatePrescriptionInventoryItemReservedQuantity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getPrescriptionInventoryItemAudits(prescriptionInventoryItemId: string, residentId: string): Promise<AuditResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/inventory/{prescriptionInventoryItemId}/audits";
        if (prescriptionInventoryItemId === undefined || prescriptionInventoryItemId === null)
            throw new Error("The parameter 'prescriptionInventoryItemId' must be defined.");
        url_ = url_.replace("{prescriptionInventoryItemId}", encodeURIComponent("" + prescriptionInventoryItemId));
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionInventoryItemAudits(_response);
        });
    }

    protected processGetPrescriptionInventoryItemAudits(response: Response): Promise<AuditResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditResponse[]>(<any>null);
    }

    getPrescriptionInventoryItemHistory(residentId: string, prescriptionInventoryItemId: string): Promise<PrescriptionInventoryItemHistoryEntryResponse[]> {
        let url_ = this.baseUrl + "/api/{residentId}/inventory/{prescriptionInventoryItemId}/history";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionInventoryItemId === undefined || prescriptionInventoryItemId === null)
            throw new Error("The parameter 'prescriptionInventoryItemId' must be defined.");
        url_ = url_.replace("{prescriptionInventoryItemId}", encodeURIComponent("" + prescriptionInventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrescriptionInventoryItemHistory(_response);
        });
    }

    protected processGetPrescriptionInventoryItemHistory(response: Response): Promise<PrescriptionInventoryItemHistoryEntryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrescriptionInventoryItemHistoryEntryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrescriptionInventoryItemHistoryEntryResponse[]>(<any>null);
    }

    deleteInventoryItem(residentId: string, prescriptionInventoryItemId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/{residentId}/inventory/{prescriptionInventoryItemId}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (prescriptionInventoryItemId === undefined || prescriptionInventoryItemId === null)
            throw new Error("The parameter 'prescriptionInventoryItemId' must be defined.");
        url_ = url_.replace("{prescriptionInventoryItemId}", encodeURIComponent("" + prescriptionInventoryItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInventoryItem(_response);
        });
    }

    protected processDeleteInventoryItem(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class RouteOfAdministrationOptionResponse implements IRouteOfAdministrationOptionResponse {
    id!: string;
    value!: string;

    constructor(data?: IRouteOfAdministrationOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RouteOfAdministrationOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RouteOfAdministrationOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IRouteOfAdministrationOptionResponse {
    id: string;
    value: string;
}

export class DosageUnitOptionResponse implements IDosageUnitOptionResponse {
    id!: string;
    value!: string;

    constructor(data?: IDosageUnitOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DosageUnitOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DosageUnitOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IDosageUnitOptionResponse {
    id: string;
    value: string;
}

export class AuditResponse implements IAuditResponse {
    executedByUserId!: string;
    auditType!: AuditType;
    timestamp!: moment.Moment;
    oldValues!: { [key: string]: any; };
    newValues!: { [key: string]: any; };

    constructor(data?: IAuditResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.oldValues = {};
            this.newValues = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executedByUserId = _data["executedByUserId"];
            this.auditType = _data["auditType"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            if (_data["oldValues"]) {
                this.oldValues = {} as any;
                for (let key in _data["oldValues"]) {
                    if (_data["oldValues"].hasOwnProperty(key))
                        (<any>this.oldValues)![key] = _data["oldValues"][key];
                }
            }
            if (_data["newValues"]) {
                this.newValues = {} as any;
                for (let key in _data["newValues"]) {
                    if (_data["newValues"].hasOwnProperty(key))
                        (<any>this.newValues)![key] = _data["newValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): AuditResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuditResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executedByUserId"] = this.executedByUserId;
        data["auditType"] = this.auditType;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        if (this.oldValues) {
            data["oldValues"] = {};
            for (let key in this.oldValues) {
                if (this.oldValues.hasOwnProperty(key))
                    (<any>data["oldValues"])[key] = this.oldValues[key];
            }
        }
        if (this.newValues) {
            data["newValues"] = {};
            for (let key in this.newValues) {
                if (this.newValues.hasOwnProperty(key))
                    (<any>data["newValues"])[key] = this.newValues[key];
            }
        }
        return data; 
    }
}

export interface IAuditResponse {
    executedByUserId: string;
    auditType: AuditType;
    timestamp: moment.Moment;
    oldValues: { [key: string]: any; };
    newValues: { [key: string]: any; };
}

export enum AuditType {
    None = "None",
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class CreatePnPrescriptionRequest implements ICreatePnPrescriptionRequest {
    strength!: string;
    form!: string;
    drugName!: string;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOptionId!: string;
    selectedDosageUnitOptionId!: string;
    remarks?: string | undefined;
    maxDosageQuantity?: number | undefined;
    noMaxDosage!: boolean;
    selectedEffectRegistrationStartTimeOptionId!: string;
    selectedEffectRegistrationCompletionTimeOptionId!: string;

    constructor(data?: ICreatePnPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.selectedRouteOfAdministrationOptionId = _data["selectedRouteOfAdministrationOptionId"];
            this.selectedDosageUnitOptionId = _data["selectedDosageUnitOptionId"];
            this.remarks = _data["remarks"];
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.noMaxDosage = _data["noMaxDosage"];
            this.selectedEffectRegistrationStartTimeOptionId = _data["selectedEffectRegistrationStartTimeOptionId"];
            this.selectedEffectRegistrationCompletionTimeOptionId = _data["selectedEffectRegistrationCompletionTimeOptionId"];
        }
    }

    static fromJS(data: any): CreatePnPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePnPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["selectedRouteOfAdministrationOptionId"] = this.selectedRouteOfAdministrationOptionId;
        data["selectedDosageUnitOptionId"] = this.selectedDosageUnitOptionId;
        data["remarks"] = this.remarks;
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["noMaxDosage"] = this.noMaxDosage;
        data["selectedEffectRegistrationStartTimeOptionId"] = this.selectedEffectRegistrationStartTimeOptionId;
        data["selectedEffectRegistrationCompletionTimeOptionId"] = this.selectedEffectRegistrationCompletionTimeOptionId;
        return data; 
    }
}

export interface ICreatePnPrescriptionRequest {
    strength: string;
    form: string;
    drugName: string;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOptionId: string;
    selectedDosageUnitOptionId: string;
    remarks?: string | undefined;
    maxDosageQuantity?: number | undefined;
    noMaxDosage: boolean;
    selectedEffectRegistrationStartTimeOptionId: string;
    selectedEffectRegistrationCompletionTimeOptionId: string;
}

export class UpdatePnPrescriptionRequest implements IUpdatePnPrescriptionRequest {
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOptionId!: string;
    selectedDosageUnitOptionId!: string;
    remarks?: string | undefined;
    maxDosageQuantity?: number | undefined;
    noMaxDosage!: boolean;
    canCancel!: boolean;
    selectedEffectRegistrationStartTimeOptionId!: string;
    selectedEffectRegistrationCompletionTimeOptionId!: string;

    constructor(data?: IUpdatePnPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.selectedRouteOfAdministrationOptionId = _data["selectedRouteOfAdministrationOptionId"];
            this.selectedDosageUnitOptionId = _data["selectedDosageUnitOptionId"];
            this.remarks = _data["remarks"];
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.noMaxDosage = _data["noMaxDosage"];
            this.canCancel = _data["canCancel"];
            this.selectedEffectRegistrationStartTimeOptionId = _data["selectedEffectRegistrationStartTimeOptionId"];
            this.selectedEffectRegistrationCompletionTimeOptionId = _data["selectedEffectRegistrationCompletionTimeOptionId"];
        }
    }

    static fromJS(data: any): UpdatePnPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePnPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["selectedRouteOfAdministrationOptionId"] = this.selectedRouteOfAdministrationOptionId;
        data["selectedDosageUnitOptionId"] = this.selectedDosageUnitOptionId;
        data["remarks"] = this.remarks;
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["noMaxDosage"] = this.noMaxDosage;
        data["canCancel"] = this.canCancel;
        data["selectedEffectRegistrationStartTimeOptionId"] = this.selectedEffectRegistrationStartTimeOptionId;
        data["selectedEffectRegistrationCompletionTimeOptionId"] = this.selectedEffectRegistrationCompletionTimeOptionId;
        return data; 
    }
}

export interface IUpdatePnPrescriptionRequest {
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOptionId: string;
    selectedDosageUnitOptionId: string;
    remarks?: string | undefined;
    maxDosageQuantity?: number | undefined;
    noMaxDosage: boolean;
    canCancel: boolean;
    selectedEffectRegistrationStartTimeOptionId: string;
    selectedEffectRegistrationCompletionTimeOptionId: string;
}

export class UpdatePnPrescriptionDelegationsRequest implements IUpdatePnPrescriptionDelegationsRequest {
    delegatedProfessionId!: number;
    primaryProfessionId!: number;
    delegationIds!: string[];

    constructor(data?: IUpdatePnPrescriptionDelegationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.delegationIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.primaryProfessionId = _data["primaryProfessionId"];
            if (Array.isArray(_data["delegationIds"])) {
                this.delegationIds = [] as any;
                for (let item of _data["delegationIds"])
                    this.delegationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePnPrescriptionDelegationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePnPrescriptionDelegationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["primaryProfessionId"] = this.primaryProfessionId;
        if (Array.isArray(this.delegationIds)) {
            data["delegationIds"] = [];
            for (let item of this.delegationIds)
                data["delegationIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdatePnPrescriptionDelegationsRequest {
    delegatedProfessionId: number;
    primaryProfessionId: number;
    delegationIds: string[];
}

export class EffectRegistrationOptionsResponse implements IEffectRegistrationOptionsResponse {
    startTimeOptions!: EffectRegistrationStartTimeOptionResponse[];
    completionTimeOptions!: EffectRegistrationCompletionTimeOptionResponse[];

    constructor(data?: IEffectRegistrationOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.startTimeOptions = [];
            this.completionTimeOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["startTimeOptions"])) {
                this.startTimeOptions = [] as any;
                for (let item of _data["startTimeOptions"])
                    this.startTimeOptions!.push(EffectRegistrationStartTimeOptionResponse.fromJS(item));
            }
            if (Array.isArray(_data["completionTimeOptions"])) {
                this.completionTimeOptions = [] as any;
                for (let item of _data["completionTimeOptions"])
                    this.completionTimeOptions!.push(EffectRegistrationCompletionTimeOptionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EffectRegistrationOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EffectRegistrationOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.startTimeOptions)) {
            data["startTimeOptions"] = [];
            for (let item of this.startTimeOptions)
                data["startTimeOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.completionTimeOptions)) {
            data["completionTimeOptions"] = [];
            for (let item of this.completionTimeOptions)
                data["completionTimeOptions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEffectRegistrationOptionsResponse {
    startTimeOptions: EffectRegistrationStartTimeOptionResponse[];
    completionTimeOptions: EffectRegistrationCompletionTimeOptionResponse[];
}

export class EffectRegistrationStartTimeOptionResponse implements IEffectRegistrationStartTimeOptionResponse {
    id!: string;
    startTimeAfterRegistrationInMinutes!: number;

    constructor(data?: IEffectRegistrationStartTimeOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTimeAfterRegistrationInMinutes = _data["startTimeAfterRegistrationInMinutes"];
        }
    }

    static fromJS(data: any): EffectRegistrationStartTimeOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EffectRegistrationStartTimeOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTimeAfterRegistrationInMinutes"] = this.startTimeAfterRegistrationInMinutes;
        return data; 
    }
}

export interface IEffectRegistrationStartTimeOptionResponse {
    id: string;
    startTimeAfterRegistrationInMinutes: number;
}

export class EffectRegistrationCompletionTimeOptionResponse implements IEffectRegistrationCompletionTimeOptionResponse {
    id!: string;
    completionTimeInMinutes!: number;

    constructor(data?: IEffectRegistrationCompletionTimeOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.completionTimeInMinutes = _data["completionTimeInMinutes"];
        }
    }

    static fromJS(data: any): EffectRegistrationCompletionTimeOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EffectRegistrationCompletionTimeOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completionTimeInMinutes"] = this.completionTimeInMinutes;
        return data; 
    }
}

export interface IEffectRegistrationCompletionTimeOptionResponse {
    id: string;
    completionTimeInMinutes: number;
}

export class PnPrescriptionMetaDataResponse implements IPnPrescriptionMetaDataResponse {
    id!: string;
    residentId!: string;
    strength!: string;
    form!: string;
    drugName!: string;
    maxDosageQuantity?: number | undefined;
    dosageUnit!: string;
    routeOfAdministration!: string;
    hasInventory!: boolean;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    state!: PrescriptionState;
    maxDosageState!: MaxDosageState;

    constructor(data?: IPnPrescriptionMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.residentId = _data["residentId"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.dosageUnit = _data["dosageUnit"];
            this.routeOfAdministration = _data["routeOfAdministration"];
            this.hasInventory = _data["hasInventory"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.maxDosageState = _data["maxDosageState"];
        }
    }

    static fromJS(data: any): PnPrescriptionMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnPrescriptionMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["residentId"] = this.residentId;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["dosageUnit"] = this.dosageUnit;
        data["routeOfAdministration"] = this.routeOfAdministration;
        data["hasInventory"] = this.hasInventory;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["maxDosageState"] = this.maxDosageState;
        return data; 
    }
}

export interface IPnPrescriptionMetaDataResponse {
    id: string;
    residentId: string;
    strength: string;
    form: string;
    drugName: string;
    maxDosageQuantity?: number | undefined;
    dosageUnit: string;
    routeOfAdministration: string;
    hasInventory: boolean;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    state: PrescriptionState;
    maxDosageState: MaxDosageState;
}

export enum PrescriptionState {
    Undefined = "Undefined",
    Active = "Active",
    Inactive = "Inactive",
    Paused = "Paused",
}

export enum MaxDosageState {
    None = "None",
    LessThan = "LessThan",
    GreaterThan = "GreaterThan",
    Equal = "Equal",
}

export class PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse implements IPnPrescriptionWithTotalAmountInMaxDosageIntervalResponse {
    id!: string;
    strength!: string;
    form!: string;
    drugName!: string;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOption!: RouteOfAdministrationOptionResponse;
    selectedDosageUnitOption!: DosageUnitOptionResponse;
    remarks?: string | undefined;
    residentId!: string;
    customerId!: string;
    canCancel!: boolean;
    delegatedProfessionId!: number;
    primaryProfessionId!: number;
    delegationTagIds!: string[];
    maxDosageQuantity?: number | undefined;
    noMaxDosage!: boolean;
    state!: PrescriptionState;
    selectedEffectRegistrationStartTimeOption!: EffectRegistrationStartTimeOptionResponse;
    selectedEffectRegistrationCompletionTimeOption!: EffectRegistrationCompletionTimeOptionResponse;
    totalAmountForRegistrationsInMaxDosageInterval?: number | undefined;
    maxDosageState!: MaxDosageState;

    constructor(data?: IPnPrescriptionWithTotalAmountInMaxDosageIntervalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedRouteOfAdministrationOption = new RouteOfAdministrationOptionResponse();
            this.selectedDosageUnitOption = new DosageUnitOptionResponse();
            this.delegationTagIds = [];
            this.selectedEffectRegistrationStartTimeOption = new EffectRegistrationStartTimeOptionResponse();
            this.selectedEffectRegistrationCompletionTimeOption = new EffectRegistrationCompletionTimeOptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.selectedRouteOfAdministrationOption = _data["selectedRouteOfAdministrationOption"] ? RouteOfAdministrationOptionResponse.fromJS(_data["selectedRouteOfAdministrationOption"]) : new RouteOfAdministrationOptionResponse();
            this.selectedDosageUnitOption = _data["selectedDosageUnitOption"] ? DosageUnitOptionResponse.fromJS(_data["selectedDosageUnitOption"]) : new DosageUnitOptionResponse();
            this.remarks = _data["remarks"];
            this.residentId = _data["residentId"];
            this.customerId = _data["customerId"];
            this.canCancel = _data["canCancel"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.primaryProfessionId = _data["primaryProfessionId"];
            if (Array.isArray(_data["delegationTagIds"])) {
                this.delegationTagIds = [] as any;
                for (let item of _data["delegationTagIds"])
                    this.delegationTagIds!.push(item);
            }
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.noMaxDosage = _data["noMaxDosage"];
            this.state = _data["state"];
            this.selectedEffectRegistrationStartTimeOption = _data["selectedEffectRegistrationStartTimeOption"] ? EffectRegistrationStartTimeOptionResponse.fromJS(_data["selectedEffectRegistrationStartTimeOption"]) : new EffectRegistrationStartTimeOptionResponse();
            this.selectedEffectRegistrationCompletionTimeOption = _data["selectedEffectRegistrationCompletionTimeOption"] ? EffectRegistrationCompletionTimeOptionResponse.fromJS(_data["selectedEffectRegistrationCompletionTimeOption"]) : new EffectRegistrationCompletionTimeOptionResponse();
            this.totalAmountForRegistrationsInMaxDosageInterval = _data["totalAmountForRegistrationsInMaxDosageInterval"];
            this.maxDosageState = _data["maxDosageState"];
        }
    }

    static fromJS(data: any): PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnPrescriptionWithTotalAmountInMaxDosageIntervalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["selectedRouteOfAdministrationOption"] = this.selectedRouteOfAdministrationOption ? this.selectedRouteOfAdministrationOption.toJSON() : <any>undefined;
        data["selectedDosageUnitOption"] = this.selectedDosageUnitOption ? this.selectedDosageUnitOption.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["residentId"] = this.residentId;
        data["customerId"] = this.customerId;
        data["canCancel"] = this.canCancel;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["primaryProfessionId"] = this.primaryProfessionId;
        if (Array.isArray(this.delegationTagIds)) {
            data["delegationTagIds"] = [];
            for (let item of this.delegationTagIds)
                data["delegationTagIds"].push(item);
        }
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["noMaxDosage"] = this.noMaxDosage;
        data["state"] = this.state;
        data["selectedEffectRegistrationStartTimeOption"] = this.selectedEffectRegistrationStartTimeOption ? this.selectedEffectRegistrationStartTimeOption.toJSON() : <any>undefined;
        data["selectedEffectRegistrationCompletionTimeOption"] = this.selectedEffectRegistrationCompletionTimeOption ? this.selectedEffectRegistrationCompletionTimeOption.toJSON() : <any>undefined;
        data["totalAmountForRegistrationsInMaxDosageInterval"] = this.totalAmountForRegistrationsInMaxDosageInterval;
        data["maxDosageState"] = this.maxDosageState;
        return data; 
    }
}

export interface IPnPrescriptionWithTotalAmountInMaxDosageIntervalResponse {
    id: string;
    strength: string;
    form: string;
    drugName: string;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOption: RouteOfAdministrationOptionResponse;
    selectedDosageUnitOption: DosageUnitOptionResponse;
    remarks?: string | undefined;
    residentId: string;
    customerId: string;
    canCancel: boolean;
    delegatedProfessionId: number;
    primaryProfessionId: number;
    delegationTagIds: string[];
    maxDosageQuantity?: number | undefined;
    noMaxDosage: boolean;
    state: PrescriptionState;
    selectedEffectRegistrationStartTimeOption: EffectRegistrationStartTimeOptionResponse;
    selectedEffectRegistrationCompletionTimeOption: EffectRegistrationCompletionTimeOptionResponse;
    totalAmountForRegistrationsInMaxDosageInterval?: number | undefined;
    maxDosageState: MaxDosageState;
}

export class CreatePnRegistrationRequest implements ICreatePnRegistrationRequest {
    observedAt!: moment.Moment;
    registrationState!: RegistrationState;
    amount!: number;
    prescriptionId!: string;
    reason!: string;
    missingDelegationReason?: string | undefined;
    effectRegistration!: CreateEffectRegistrationRequest;
    forceOnError!: boolean;

    constructor(data?: ICreatePnRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.effectRegistration = new CreateEffectRegistrationRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            this.registrationState = _data["registrationState"];
            this.amount = _data["amount"];
            this.prescriptionId = _data["prescriptionId"];
            this.reason = _data["reason"];
            this.missingDelegationReason = _data["missingDelegationReason"];
            this.effectRegistration = _data["effectRegistration"] ? CreateEffectRegistrationRequest.fromJS(_data["effectRegistration"]) : new CreateEffectRegistrationRequest();
            this.forceOnError = _data["forceOnError"];
        }
    }

    static fromJS(data: any): CreatePnRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePnRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        data["registrationState"] = this.registrationState;
        data["amount"] = this.amount;
        data["prescriptionId"] = this.prescriptionId;
        data["reason"] = this.reason;
        data["missingDelegationReason"] = this.missingDelegationReason;
        data["effectRegistration"] = this.effectRegistration ? this.effectRegistration.toJSON() : <any>undefined;
        data["forceOnError"] = this.forceOnError;
        return data; 
    }
}

export interface ICreatePnRegistrationRequest {
    observedAt: moment.Moment;
    registrationState: RegistrationState;
    amount: number;
    prescriptionId: string;
    reason: string;
    missingDelegationReason?: string | undefined;
    effectRegistration: CreateEffectRegistrationRequest;
    forceOnError: boolean;
}

export enum RegistrationState {
    Undefined = "Undefined",
    None = "None",
    Given = "Given",
    HandedOver = "HandedOver",
    NotGiven = "NotGiven",
    NotIngested = "NotIngested",
}

export class CreateEffectRegistrationRequest implements ICreateEffectRegistrationRequest {
    state!: State;
    effect?: string | undefined;
    startTimeOptionId?: string | undefined;

    constructor(data?: ICreateEffectRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.effect = _data["effect"];
            this.startTimeOptionId = _data["startTimeOptionId"];
        }
    }

    static fromJS(data: any): CreateEffectRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEffectRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["effect"] = this.effect;
        data["startTimeOptionId"] = this.startTimeOptionId;
        return data; 
    }
}

export interface ICreateEffectRegistrationRequest {
    state: State;
    effect?: string | undefined;
    startTimeOptionId?: string | undefined;
}

export enum State {
    Undefined = "Undefined",
    Ready = "Ready",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export class UpdatePnRegistrationRequest implements IUpdatePnRegistrationRequest {
    registrationState!: RegistrationState;
    reason!: string;
    missingDelegationReason?: string | undefined;
    forceOnError!: boolean;

    constructor(data?: IUpdatePnRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationState = _data["registrationState"];
            this.reason = _data["reason"];
            this.missingDelegationReason = _data["missingDelegationReason"];
            this.forceOnError = _data["forceOnError"];
        }
    }

    static fromJS(data: any): UpdatePnRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePnRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationState"] = this.registrationState;
        data["reason"] = this.reason;
        data["missingDelegationReason"] = this.missingDelegationReason;
        data["forceOnError"] = this.forceOnError;
        return data; 
    }
}

export interface IUpdatePnRegistrationRequest {
    registrationState: RegistrationState;
    reason: string;
    missingDelegationReason?: string | undefined;
    forceOnError: boolean;
}

export class PnRegistrationMetaDataResponse implements IPnRegistrationMetaDataResponse {
    id!: string;
    lastUpdatedAt!: moment.Moment;
    observedAt!: moment.Moment;
    lastUpdatedBy!: string;
    amount!: number;
    reason!: string;
    effectRegistration!: PnEffectRegistrationMetaDataResponse;
    registrationState!: RegistrationState;
    state!: State;

    constructor(data?: IPnRegistrationMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.effectRegistration = new PnEffectRegistrationMetaDataResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.amount = _data["amount"];
            this.reason = _data["reason"];
            this.effectRegistration = _data["effectRegistration"] ? PnEffectRegistrationMetaDataResponse.fromJS(_data["effectRegistration"]) : new PnEffectRegistrationMetaDataResponse();
            this.registrationState = _data["registrationState"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PnRegistrationMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnRegistrationMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["amount"] = this.amount;
        data["reason"] = this.reason;
        data["effectRegistration"] = this.effectRegistration ? this.effectRegistration.toJSON() : <any>undefined;
        data["registrationState"] = this.registrationState;
        data["state"] = this.state;
        return data; 
    }
}

export interface IPnRegistrationMetaDataResponse {
    id: string;
    lastUpdatedAt: moment.Moment;
    observedAt: moment.Moment;
    lastUpdatedBy: string;
    amount: number;
    reason: string;
    effectRegistration: PnEffectRegistrationMetaDataResponse;
    registrationState: RegistrationState;
    state: State;
}

export class PnEffectRegistrationMetaDataResponse implements IPnEffectRegistrationMetaDataResponse {
    lastUpdatedAt!: moment.Moment;
    lastUpdatedBy!: string;
    effect?: string | undefined;
    state!: State;

    constructor(data?: IPnEffectRegistrationMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.effect = _data["effect"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PnEffectRegistrationMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["effect"] = this.effect;
        data["state"] = this.state;
        return data; 
    }
}

export interface IPnEffectRegistrationMetaDataResponse {
    lastUpdatedAt: moment.Moment;
    lastUpdatedBy: string;
    effect?: string | undefined;
    state: State;
}

export class PnRegistrationResponse implements IPnRegistrationResponse {
    id!: string;
    registeredAt!: moment.Moment;
    lastUpdatedAt!: moment.Moment;
    observedAt!: moment.Moment;
    registeredBy!: string;
    lastUpdatedBy!: string;
    registrationState!: RegistrationState;
    state!: State;
    amount!: number;
    reason!: string;
    effectRegistration!: PnEffectRegistrationResponse;
    pnPrescription!: PnPrescriptionResponse;

    constructor(data?: IPnRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.effectRegistration = new PnEffectRegistrationResponse();
            this.pnPrescription = new PnPrescriptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registeredAt = _data["registeredAt"] ? moment(_data["registeredAt"].toString()) : <any>undefined;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            this.registeredBy = _data["registeredBy"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.registrationState = _data["registrationState"];
            this.state = _data["state"];
            this.amount = _data["amount"];
            this.reason = _data["reason"];
            this.effectRegistration = _data["effectRegistration"] ? PnEffectRegistrationResponse.fromJS(_data["effectRegistration"]) : new PnEffectRegistrationResponse();
            this.pnPrescription = _data["pnPrescription"] ? PnPrescriptionResponse.fromJS(_data["pnPrescription"]) : new PnPrescriptionResponse();
        }
    }

    static fromJS(data: any): PnRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registeredAt"] = this.registeredAt ? this.registeredAt.toISOString() : <any>undefined;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        data["registeredBy"] = this.registeredBy;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["registrationState"] = this.registrationState;
        data["state"] = this.state;
        data["amount"] = this.amount;
        data["reason"] = this.reason;
        data["effectRegistration"] = this.effectRegistration ? this.effectRegistration.toJSON() : <any>undefined;
        data["pnPrescription"] = this.pnPrescription ? this.pnPrescription.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPnRegistrationResponse {
    id: string;
    registeredAt: moment.Moment;
    lastUpdatedAt: moment.Moment;
    observedAt: moment.Moment;
    registeredBy: string;
    lastUpdatedBy: string;
    registrationState: RegistrationState;
    state: State;
    amount: number;
    reason: string;
    effectRegistration: PnEffectRegistrationResponse;
    pnPrescription: PnPrescriptionResponse;
}

export class PnEffectRegistrationResponse implements IPnEffectRegistrationResponse {
    id!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    lastUpdatedAt!: moment.Moment;
    lastUpdatedBy!: string;
    effect?: string | undefined;
    state!: State;
    reason?: string | undefined;

    constructor(data?: IPnEffectRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.effect = _data["effect"];
            this.state = _data["state"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PnEffectRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["effect"] = this.effect;
        data["state"] = this.state;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface IPnEffectRegistrationResponse {
    id: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
    lastUpdatedAt: moment.Moment;
    lastUpdatedBy: string;
    effect?: string | undefined;
    state: State;
    reason?: string | undefined;
}

export class PnPrescriptionResponse implements IPnPrescriptionResponse {
    id!: string;
    strength!: string;
    form!: string;
    drugName!: string;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOption!: RouteOfAdministrationOptionResponse;
    selectedDosageUnitOption!: DosageUnitOptionResponse;
    remarks?: string | undefined;
    residentId!: string;
    customerId!: string;
    canCancel!: boolean;
    delegatedProfessionId!: number;
    primaryProfessionId!: number;
    delegationTagIds!: string[];
    maxDosageQuantity?: number | undefined;
    noMaxDosage!: boolean;
    state!: PrescriptionState;
    selectedEffectRegistrationStartTimeOption!: EffectRegistrationStartTimeOptionResponse;
    selectedEffectRegistrationCompletionTimeOption!: EffectRegistrationCompletionTimeOptionResponse;

    constructor(data?: IPnPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedRouteOfAdministrationOption = new RouteOfAdministrationOptionResponse();
            this.selectedDosageUnitOption = new DosageUnitOptionResponse();
            this.delegationTagIds = [];
            this.selectedEffectRegistrationStartTimeOption = new EffectRegistrationStartTimeOptionResponse();
            this.selectedEffectRegistrationCompletionTimeOption = new EffectRegistrationCompletionTimeOptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.selectedRouteOfAdministrationOption = _data["selectedRouteOfAdministrationOption"] ? RouteOfAdministrationOptionResponse.fromJS(_data["selectedRouteOfAdministrationOption"]) : new RouteOfAdministrationOptionResponse();
            this.selectedDosageUnitOption = _data["selectedDosageUnitOption"] ? DosageUnitOptionResponse.fromJS(_data["selectedDosageUnitOption"]) : new DosageUnitOptionResponse();
            this.remarks = _data["remarks"];
            this.residentId = _data["residentId"];
            this.customerId = _data["customerId"];
            this.canCancel = _data["canCancel"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.primaryProfessionId = _data["primaryProfessionId"];
            if (Array.isArray(_data["delegationTagIds"])) {
                this.delegationTagIds = [] as any;
                for (let item of _data["delegationTagIds"])
                    this.delegationTagIds!.push(item);
            }
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.noMaxDosage = _data["noMaxDosage"];
            this.state = _data["state"];
            this.selectedEffectRegistrationStartTimeOption = _data["selectedEffectRegistrationStartTimeOption"] ? EffectRegistrationStartTimeOptionResponse.fromJS(_data["selectedEffectRegistrationStartTimeOption"]) : new EffectRegistrationStartTimeOptionResponse();
            this.selectedEffectRegistrationCompletionTimeOption = _data["selectedEffectRegistrationCompletionTimeOption"] ? EffectRegistrationCompletionTimeOptionResponse.fromJS(_data["selectedEffectRegistrationCompletionTimeOption"]) : new EffectRegistrationCompletionTimeOptionResponse();
        }
    }

    static fromJS(data: any): PnPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["selectedRouteOfAdministrationOption"] = this.selectedRouteOfAdministrationOption ? this.selectedRouteOfAdministrationOption.toJSON() : <any>undefined;
        data["selectedDosageUnitOption"] = this.selectedDosageUnitOption ? this.selectedDosageUnitOption.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["residentId"] = this.residentId;
        data["customerId"] = this.customerId;
        data["canCancel"] = this.canCancel;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["primaryProfessionId"] = this.primaryProfessionId;
        if (Array.isArray(this.delegationTagIds)) {
            data["delegationTagIds"] = [];
            for (let item of this.delegationTagIds)
                data["delegationTagIds"].push(item);
        }
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["noMaxDosage"] = this.noMaxDosage;
        data["state"] = this.state;
        data["selectedEffectRegistrationStartTimeOption"] = this.selectedEffectRegistrationStartTimeOption ? this.selectedEffectRegistrationStartTimeOption.toJSON() : <any>undefined;
        data["selectedEffectRegistrationCompletionTimeOption"] = this.selectedEffectRegistrationCompletionTimeOption ? this.selectedEffectRegistrationCompletionTimeOption.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPnPrescriptionResponse {
    id: string;
    strength: string;
    form: string;
    drugName: string;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    selectedRouteOfAdministrationOption: RouteOfAdministrationOptionResponse;
    selectedDosageUnitOption: DosageUnitOptionResponse;
    remarks?: string | undefined;
    residentId: string;
    customerId: string;
    canCancel: boolean;
    delegatedProfessionId: number;
    primaryProfessionId: number;
    delegationTagIds: string[];
    maxDosageQuantity?: number | undefined;
    noMaxDosage: boolean;
    state: PrescriptionState;
    selectedEffectRegistrationStartTimeOption: EffectRegistrationStartTimeOptionResponse;
    selectedEffectRegistrationCompletionTimeOption: EffectRegistrationCompletionTimeOptionResponse;
}

export class UpdatePnEffectRegistrationRequest implements IUpdatePnEffectRegistrationRequest {
    state!: State;
    effect?: string | undefined;
    missingDelegationReason?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IUpdatePnEffectRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.effect = _data["effect"];
            this.missingDelegationReason = _data["missingDelegationReason"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdatePnEffectRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePnEffectRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["effect"] = this.effect;
        data["missingDelegationReason"] = this.missingDelegationReason;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface IUpdatePnEffectRegistrationRequest {
    state: State;
    effect?: string | undefined;
    missingDelegationReason?: string | undefined;
    reason?: string | undefined;
}

export class GetPnPrescriptionsResponse implements IGetPnPrescriptionsResponse {
    id!: string;
    residentId!: string;
    strength!: string;
    form!: string;
    drugName!: string;

    constructor(data?: IGetPnPrescriptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.residentId = _data["residentId"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
        }
    }

    static fromJS(data: any): GetPnPrescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPnPrescriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["residentId"] = this.residentId;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        return data; 
    }
}

export interface IGetPnPrescriptionsResponse {
    id: string;
    residentId: string;
    strength: string;
    form: string;
    drugName: string;
}

export class GetPnPrescriptionsRequest implements IGetPnPrescriptionsRequest {
    prescriptionIds!: string[];

    constructor(data?: IGetPnPrescriptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescriptionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prescriptionIds"])) {
                this.prescriptionIds = [] as any;
                for (let item of _data["prescriptionIds"])
                    this.prescriptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPnPrescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPnPrescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prescriptionIds)) {
            data["prescriptionIds"] = [];
            for (let item of this.prescriptionIds)
                data["prescriptionIds"].push(item);
        }
        return data; 
    }
}

export interface IGetPnPrescriptionsRequest {
    prescriptionIds: string[];
}

export class PnRegistrationHistoryResponse implements IPnRegistrationHistoryResponse {
    registrationHistory!: PnRegistrationHistoryEntryResponse[];
    effectRegistrationHistory!: PnEffectRegistrationHistoryEntryResponse[];

    constructor(data?: IPnRegistrationHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.registrationHistory = [];
            this.effectRegistrationHistory = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["registrationHistory"])) {
                this.registrationHistory = [] as any;
                for (let item of _data["registrationHistory"])
                    this.registrationHistory!.push(PnRegistrationHistoryEntryResponse.fromJS(item));
            }
            if (Array.isArray(_data["effectRegistrationHistory"])) {
                this.effectRegistrationHistory = [] as any;
                for (let item of _data["effectRegistrationHistory"])
                    this.effectRegistrationHistory!.push(PnEffectRegistrationHistoryEntryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PnRegistrationHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnRegistrationHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrationHistory)) {
            data["registrationHistory"] = [];
            for (let item of this.registrationHistory)
                data["registrationHistory"].push(item.toJSON());
        }
        if (Array.isArray(this.effectRegistrationHistory)) {
            data["effectRegistrationHistory"] = [];
            for (let item of this.effectRegistrationHistory)
                data["effectRegistrationHistory"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPnRegistrationHistoryResponse {
    registrationHistory: PnRegistrationHistoryEntryResponse[];
    effectRegistrationHistory: PnEffectRegistrationHistoryEntryResponse[];
}

export class PnRegistrationHistoryEntryResponse implements IPnRegistrationHistoryEntryResponse {
    timestamp!: moment.Moment;
    executingEmployeeId!: string;
    registrationState!: RegistrationState;
    state!: State;
    reason?: string | undefined;
    missingDelegationReason?: string | undefined;

    constructor(data?: IPnRegistrationHistoryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.executingEmployeeId = _data["executingEmployeeId"];
            this.registrationState = _data["registrationState"];
            this.state = _data["state"];
            this.reason = _data["reason"];
            this.missingDelegationReason = _data["missingDelegationReason"];
        }
    }

    static fromJS(data: any): PnRegistrationHistoryEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnRegistrationHistoryEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["executingEmployeeId"] = this.executingEmployeeId;
        data["registrationState"] = this.registrationState;
        data["state"] = this.state;
        data["reason"] = this.reason;
        data["missingDelegationReason"] = this.missingDelegationReason;
        return data; 
    }
}

export interface IPnRegistrationHistoryEntryResponse {
    timestamp: moment.Moment;
    executingEmployeeId: string;
    registrationState: RegistrationState;
    state: State;
    reason?: string | undefined;
    missingDelegationReason?: string | undefined;
}

export class PnEffectRegistrationHistoryEntryResponse implements IPnEffectRegistrationHistoryEntryResponse {
    timestamp!: moment.Moment;
    executingEmployeeId!: string;
    state!: HistoryState;
    effect?: string | undefined;
    missingDelegationReason?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IPnEffectRegistrationHistoryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.executingEmployeeId = _data["executingEmployeeId"];
            this.state = _data["state"];
            this.effect = _data["effect"];
            this.missingDelegationReason = _data["missingDelegationReason"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PnEffectRegistrationHistoryEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationHistoryEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["executingEmployeeId"] = this.executingEmployeeId;
        data["state"] = this.state;
        data["effect"] = this.effect;
        data["missingDelegationReason"] = this.missingDelegationReason;
        data["reason"] = this.reason;
        return data; 
    }
}

export interface IPnEffectRegistrationHistoryEntryResponse {
    timestamp: moment.Moment;
    executingEmployeeId: string;
    state: HistoryState;
    effect?: string | undefined;
    missingDelegationReason?: string | undefined;
    reason?: string | undefined;
}

export enum HistoryState {
    Undefined = "Undefined",
    Undid = "Undid",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Updated = "Updated",
}

export class CreateNotDispensedPrescriptionRequest implements ICreateNotDispensedPrescriptionRequest {
    strength!: string;
    form!: string;
    drugName!: string;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    remarks?: string | undefined;
    selectedRouteOfAdministrationOptionId!: string;
    selectedDosageUnitOptionId!: string;

    constructor(data?: ICreateNotDispensedPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.selectedRouteOfAdministrationOptionId = _data["selectedRouteOfAdministrationOptionId"];
            this.selectedDosageUnitOptionId = _data["selectedDosageUnitOptionId"];
        }
    }

    static fromJS(data: any): CreateNotDispensedPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotDispensedPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["selectedRouteOfAdministrationOptionId"] = this.selectedRouteOfAdministrationOptionId;
        data["selectedDosageUnitOptionId"] = this.selectedDosageUnitOptionId;
        return data; 
    }
}

export interface ICreateNotDispensedPrescriptionRequest {
    strength: string;
    form: string;
    drugName: string;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    remarks?: string | undefined;
    selectedRouteOfAdministrationOptionId: string;
    selectedDosageUnitOptionId: string;
}

export class UpdateNotDispensedPrescriptionRequest implements IUpdateNotDispensedPrescriptionRequest {
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    remarks?: string | undefined;
    selectedRouteOfAdministrationOptionId!: string;
    selectedDosageUnitOptionId!: string;

    constructor(data?: IUpdateNotDispensedPrescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.selectedRouteOfAdministrationOptionId = _data["selectedRouteOfAdministrationOptionId"];
            this.selectedDosageUnitOptionId = _data["selectedDosageUnitOptionId"];
        }
    }

    static fromJS(data: any): UpdateNotDispensedPrescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotDispensedPrescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["selectedRouteOfAdministrationOptionId"] = this.selectedRouteOfAdministrationOptionId;
        data["selectedDosageUnitOptionId"] = this.selectedDosageUnitOptionId;
        return data; 
    }
}

export interface IUpdateNotDispensedPrescriptionRequest {
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    remarks?: string | undefined;
    selectedRouteOfAdministrationOptionId: string;
    selectedDosageUnitOptionId: string;
}

export class NotDispensedPrescriptionResponse implements INotDispensedPrescriptionResponse {
    id!: string;
    residentId!: string;
    customerId!: string;
    strength!: string;
    form!: string;
    drugName!: string;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    remarks?: string | undefined;
    selectedRouteOfAdministrationOption!: RouteOfAdministrationOptionResponse;
    selectedDosageUnitOption!: DosageUnitOptionResponse;
    state!: PrescriptionState;

    constructor(data?: INotDispensedPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedRouteOfAdministrationOption = new RouteOfAdministrationOptionResponse();
            this.selectedDosageUnitOption = new DosageUnitOptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.residentId = _data["residentId"];
            this.customerId = _data["customerId"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.selectedRouteOfAdministrationOption = _data["selectedRouteOfAdministrationOption"] ? RouteOfAdministrationOptionResponse.fromJS(_data["selectedRouteOfAdministrationOption"]) : new RouteOfAdministrationOptionResponse();
            this.selectedDosageUnitOption = _data["selectedDosageUnitOption"] ? DosageUnitOptionResponse.fromJS(_data["selectedDosageUnitOption"]) : new DosageUnitOptionResponse();
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): NotDispensedPrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedPrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["residentId"] = this.residentId;
        data["customerId"] = this.customerId;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["selectedRouteOfAdministrationOption"] = this.selectedRouteOfAdministrationOption ? this.selectedRouteOfAdministrationOption.toJSON() : <any>undefined;
        data["selectedDosageUnitOption"] = this.selectedDosageUnitOption ? this.selectedDosageUnitOption.toJSON() : <any>undefined;
        data["state"] = this.state;
        return data; 
    }
}

export interface INotDispensedPrescriptionResponse {
    id: string;
    residentId: string;
    customerId: string;
    strength: string;
    form: string;
    drugName: string;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    remarks?: string | undefined;
    selectedRouteOfAdministrationOption: RouteOfAdministrationOptionResponse;
    selectedDosageUnitOption: DosageUnitOptionResponse;
    state: PrescriptionState;
}

export class NotDispensedRegistrationResponse implements INotDispensedRegistrationResponse {
    id!: string;
    registeredAt!: moment.Moment;
    lastUpdatedAt!: moment.Moment;
    observedAt!: moment.Moment;
    registeredBy!: string;
    lastUpdatedBy!: string;
    registrationState!: RegistrationState;
    state!: State;
    amount!: number;
    notDispensedPrescription!: NotDispensedPrescriptionResponse;

    constructor(data?: INotDispensedRegistrationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notDispensedPrescription = new NotDispensedPrescriptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.registeredAt = _data["registeredAt"] ? moment(_data["registeredAt"].toString()) : <any>undefined;
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            this.registeredBy = _data["registeredBy"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.registrationState = _data["registrationState"];
            this.state = _data["state"];
            this.amount = _data["amount"];
            this.notDispensedPrescription = _data["notDispensedPrescription"] ? NotDispensedPrescriptionResponse.fromJS(_data["notDispensedPrescription"]) : new NotDispensedPrescriptionResponse();
        }
    }

    static fromJS(data: any): NotDispensedRegistrationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedRegistrationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["registeredAt"] = this.registeredAt ? this.registeredAt.toISOString() : <any>undefined;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        data["registeredBy"] = this.registeredBy;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["registrationState"] = this.registrationState;
        data["state"] = this.state;
        data["amount"] = this.amount;
        data["notDispensedPrescription"] = this.notDispensedPrescription ? this.notDispensedPrescription.toJSON() : <any>undefined;
        return data; 
    }
}

export interface INotDispensedRegistrationResponse {
    id: string;
    registeredAt: moment.Moment;
    lastUpdatedAt: moment.Moment;
    observedAt: moment.Moment;
    registeredBy: string;
    lastUpdatedBy: string;
    registrationState: RegistrationState;
    state: State;
    amount: number;
    notDispensedPrescription: NotDispensedPrescriptionResponse;
}

export class NotDispensedPrescriptionMetaDataResponse implements INotDispensedPrescriptionMetaDataResponse {
    id!: string;
    strength!: string;
    form!: string;
    drugName!: string;
    dosageUnit!: string;
    routeOfAdministration!: string;
    hasInventory!: boolean;
    startTime!: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    state!: PrescriptionState;

    constructor(data?: INotDispensedPrescriptionMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.drugName = _data["drugName"];
            this.dosageUnit = _data["dosageUnit"];
            this.routeOfAdministration = _data["routeOfAdministration"];
            this.hasInventory = _data["hasInventory"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.pauseStartTime = _data["pauseStartTime"] ? moment(_data["pauseStartTime"].toString()) : <any>undefined;
            this.pauseEndTime = _data["pauseEndTime"] ? moment(_data["pauseEndTime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): NotDispensedPrescriptionMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedPrescriptionMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["drugName"] = this.drugName;
        data["dosageUnit"] = this.dosageUnit;
        data["routeOfAdministration"] = this.routeOfAdministration;
        data["hasInventory"] = this.hasInventory;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["pauseStartTime"] = this.pauseStartTime ? this.pauseStartTime.toISOString() : <any>undefined;
        data["pauseEndTime"] = this.pauseEndTime ? this.pauseEndTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data; 
    }
}

export interface INotDispensedPrescriptionMetaDataResponse {
    id: string;
    strength: string;
    form: string;
    drugName: string;
    dosageUnit: string;
    routeOfAdministration: string;
    hasInventory: boolean;
    startTime: moment.Moment;
    endTime?: moment.Moment | undefined;
    pauseStartTime?: moment.Moment | undefined;
    pauseEndTime?: moment.Moment | undefined;
    state: PrescriptionState;
}

export class NotDispensedRegistrationCreatedResponse implements INotDispensedRegistrationCreatedResponse {
    notDispensedRegistrationId!: string;

    constructor(data?: INotDispensedRegistrationCreatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notDispensedRegistrationId = _data["notDispensedRegistrationId"];
        }
    }

    static fromJS(data: any): NotDispensedRegistrationCreatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedRegistrationCreatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notDispensedRegistrationId"] = this.notDispensedRegistrationId;
        return data; 
    }
}

export interface INotDispensedRegistrationCreatedResponse {
    notDispensedRegistrationId: string;
}

export class CreateNotDispensedRegistrationRequest implements ICreateNotDispensedRegistrationRequest {
    prescriptionId!: string;
    amount!: number;
    observedAt!: moment.Moment;
    registrationState!: RegistrationState;
    taskInformation!: TaskInformationRequest;
    forceOnError!: boolean;

    constructor(data?: ICreateNotDispensedRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskInformation = new TaskInformationRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"];
            this.amount = _data["amount"];
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            this.registrationState = _data["registrationState"];
            this.taskInformation = _data["taskInformation"] ? TaskInformationRequest.fromJS(_data["taskInformation"]) : new TaskInformationRequest();
            this.forceOnError = _data["forceOnError"];
        }
    }

    static fromJS(data: any): CreateNotDispensedRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotDispensedRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId;
        data["amount"] = this.amount;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        data["registrationState"] = this.registrationState;
        data["taskInformation"] = this.taskInformation ? this.taskInformation.toJSON() : <any>undefined;
        data["forceOnError"] = this.forceOnError;
        return data; 
    }
}

export interface ICreateNotDispensedRegistrationRequest {
    prescriptionId: string;
    amount: number;
    observedAt: moment.Moment;
    registrationState: RegistrationState;
    taskInformation: TaskInformationRequest;
    forceOnError: boolean;
}

export class TaskInformationRequest implements ITaskInformationRequest {
    taskInstanceId!: string;
    taskAssignmentId!: string;

    constructor(data?: ITaskInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskInstanceId = _data["taskInstanceId"];
            this.taskAssignmentId = _data["taskAssignmentId"];
        }
    }

    static fromJS(data: any): TaskInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInstanceId"] = this.taskInstanceId;
        data["taskAssignmentId"] = this.taskAssignmentId;
        return data; 
    }
}

export interface ITaskInformationRequest {
    taskInstanceId: string;
    taskAssignmentId: string;
}

export class UpdateNotDispensedRegistrationRequest implements IUpdateNotDispensedRegistrationRequest {
    registrationState!: RegistrationState;
    taskInformation!: TaskInformationRequest;
    forceOnError!: boolean;

    constructor(data?: IUpdateNotDispensedRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.taskInformation = new TaskInformationRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationState = _data["registrationState"];
            this.taskInformation = _data["taskInformation"] ? TaskInformationRequest.fromJS(_data["taskInformation"]) : new TaskInformationRequest();
            this.forceOnError = _data["forceOnError"];
        }
    }

    static fromJS(data: any): UpdateNotDispensedRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotDispensedRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationState"] = this.registrationState;
        data["taskInformation"] = this.taskInformation ? this.taskInformation.toJSON() : <any>undefined;
        data["forceOnError"] = this.forceOnError;
        return data; 
    }
}

export interface IUpdateNotDispensedRegistrationRequest {
    registrationState: RegistrationState;
    taskInformation: TaskInformationRequest;
    forceOnError: boolean;
}

export class NotDispensedRegistrationMetaDataResponse implements INotDispensedRegistrationMetaDataResponse {
    id!: string;
    lastUpdatedAt!: moment.Moment;
    observedAt!: moment.Moment;
    lastUpdatedBy!: string;
    amount!: number;
    registrationState!: RegistrationState;
    state!: State;

    constructor(data?: INotDispensedRegistrationMetaDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? moment(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.amount = _data["amount"];
            this.registrationState = _data["registrationState"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): NotDispensedRegistrationMetaDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedRegistrationMetaDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["amount"] = this.amount;
        data["registrationState"] = this.registrationState;
        data["state"] = this.state;
        return data; 
    }
}

export interface INotDispensedRegistrationMetaDataResponse {
    id: string;
    lastUpdatedAt: moment.Moment;
    observedAt: moment.Moment;
    lastUpdatedBy: string;
    amount: number;
    registrationState: RegistrationState;
    state: State;
}

export class NotDispensedRegistrationHistoryResponse implements INotDispensedRegistrationHistoryResponse {
    id!: string;
    notDispensedRegistrationId!: string;
    timestamp!: moment.Moment;
    executingEmployeeId!: string;
    registrationState!: RegistrationState;
    state!: State;

    constructor(data?: INotDispensedRegistrationHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notDispensedRegistrationId = _data["notDispensedRegistrationId"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.executingEmployeeId = _data["executingEmployeeId"];
            this.registrationState = _data["registrationState"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): NotDispensedRegistrationHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotDispensedRegistrationHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notDispensedRegistrationId"] = this.notDispensedRegistrationId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["executingEmployeeId"] = this.executingEmployeeId;
        data["registrationState"] = this.registrationState;
        data["state"] = this.state;
        return data; 
    }
}

export interface INotDispensedRegistrationHistoryResponse {
    id: string;
    notDispensedRegistrationId: string;
    timestamp: moment.Moment;
    executingEmployeeId: string;
    registrationState: RegistrationState;
    state: State;
}

export class MedicineTypeConfigurationResponse implements IMedicineTypeConfigurationResponse {
    type!: MedicineType;
    accessControlTagIds!: string[];

    constructor(data?: IMedicineTypeConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MedicineTypeConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MedicineTypeConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IMedicineTypeConfigurationResponse {
    type: MedicineType;
    accessControlTagIds: string[];
}

export enum MedicineType {
    Pn = "Pn",
}

export class UpdateMedicineTypeAccessControlRequest implements IUpdateMedicineTypeAccessControlRequest {
    accessControlTagIds!: string[];

    constructor(data?: IUpdateMedicineTypeAccessControlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMedicineTypeAccessControlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMedicineTypeAccessControlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateMedicineTypeAccessControlRequest {
    accessControlTagIds: string[];
}

export class GetMedicineTasksResponse implements IGetMedicineTasksResponse {
    pnTasks!: PnTaskResponse[];
    pnEffectTasks!: PnEffectTaskResponse[];

    constructor(data?: IGetMedicineTasksResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pnTasks = [];
            this.pnEffectTasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pnTasks"])) {
                this.pnTasks = [] as any;
                for (let item of _data["pnTasks"])
                    this.pnTasks!.push(PnTaskResponse.fromJS(item));
            }
            if (Array.isArray(_data["pnEffectTasks"])) {
                this.pnEffectTasks = [] as any;
                for (let item of _data["pnEffectTasks"])
                    this.pnEffectTasks!.push(PnEffectTaskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMedicineTasksResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicineTasksResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pnTasks)) {
            data["pnTasks"] = [];
            for (let item of this.pnTasks)
                data["pnTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.pnEffectTasks)) {
            data["pnEffectTasks"] = [];
            for (let item of this.pnEffectTasks)
                data["pnEffectTasks"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMedicineTasksResponse {
    pnTasks: PnTaskResponse[];
    pnEffectTasks: PnEffectTaskResponse[];
}

export class PnTaskResponse implements IPnTaskResponse {
    pnRegistrationId!: string;
    pnPrescriptionId!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    residentId!: string;
    delegatedProfessionId!: number;
    primaryProfessionId!: number;
    delegationTags!: string[];
    state!: State;

    constructor(data?: IPnTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnRegistrationId = _data["pnRegistrationId"];
            this.pnPrescriptionId = _data["pnPrescriptionId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.residentId = _data["residentId"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.primaryProfessionId = _data["primaryProfessionId"];
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PnTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnRegistrationId"] = this.pnRegistrationId;
        data["pnPrescriptionId"] = this.pnPrescriptionId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["residentId"] = this.residentId;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["primaryProfessionId"] = this.primaryProfessionId;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        data["state"] = this.state;
        return data; 
    }
}

export interface IPnTaskResponse {
    pnRegistrationId: string;
    pnPrescriptionId: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
    residentId: string;
    delegatedProfessionId: number;
    primaryProfessionId: number;
    delegationTags: string[];
    state: State;
}

export class PnEffectTaskResponse implements IPnEffectTaskResponse {
    pnRegistrationId!: string;
    pnPrescriptionId!: string;
    residentId!: string;
    delegatedProfessionId!: number;
    primaryProfessionId!: number;
    delegationTags!: string[];
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    state!: State;

    constructor(data?: IPnEffectTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.delegationTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnRegistrationId = _data["pnRegistrationId"];
            this.pnPrescriptionId = _data["pnPrescriptionId"];
            this.residentId = _data["residentId"];
            this.delegatedProfessionId = _data["delegatedProfessionId"];
            this.primaryProfessionId = _data["primaryProfessionId"];
            if (Array.isArray(_data["delegationTags"])) {
                this.delegationTags = [] as any;
                for (let item of _data["delegationTags"])
                    this.delegationTags!.push(item);
            }
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PnEffectTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnRegistrationId"] = this.pnRegistrationId;
        data["pnPrescriptionId"] = this.pnPrescriptionId;
        data["residentId"] = this.residentId;
        data["delegatedProfessionId"] = this.delegatedProfessionId;
        data["primaryProfessionId"] = this.primaryProfessionId;
        if (Array.isArray(this.delegationTags)) {
            data["delegationTags"] = [];
            for (let item of this.delegationTags)
                data["delegationTags"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["state"] = this.state;
        return data; 
    }
}

export interface IPnEffectTaskResponse {
    pnRegistrationId: string;
    pnPrescriptionId: string;
    residentId: string;
    delegatedProfessionId: number;
    primaryProfessionId: number;
    delegationTags: string[];
    startTime: moment.Moment;
    endTime: moment.Moment;
    state: State;
}

export class GetMedicineTasksRequest implements IGetMedicineTasksRequest {
    residentIds!: string[];
    from!: moment.Moment;
    to!: moment.Moment;

    constructor(data?: IGetMedicineTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMedicineTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicineTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetMedicineTasksRequest {
    residentIds: string[];
    from: moment.Moment;
    to: moment.Moment;
}

export class CreatePrescriptionInventoryItemRequest implements ICreatePrescriptionInventoryItemRequest {
    prescriptionId!: string;
    reservedQuantity!: number;

    constructor(data?: ICreatePrescriptionInventoryItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prescriptionId = _data["prescriptionId"];
            this.reservedQuantity = _data["reservedQuantity"];
        }
    }

    static fromJS(data: any): CreatePrescriptionInventoryItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrescriptionInventoryItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prescriptionId"] = this.prescriptionId;
        data["reservedQuantity"] = this.reservedQuantity;
        return data; 
    }
}

export interface ICreatePrescriptionInventoryItemRequest {
    prescriptionId: string;
    reservedQuantity: number;
}

export class PrescriptionInventoryItemResponse implements IPrescriptionInventoryItemResponse {
    inventoryItemId!: string;
    prescriptionType!: PrescriptionTypeResponse;
    reservedQuantity!: number;
    usedQuantity!: number;
    state!: InventoryItemState;
    prescription!: PrescriptionResponse;

    constructor(data?: IPrescriptionInventoryItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.prescription = new PrescriptionResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryItemId = _data["inventoryItemId"];
            this.prescriptionType = _data["prescriptionType"];
            this.reservedQuantity = _data["reservedQuantity"];
            this.usedQuantity = _data["usedQuantity"];
            this.state = _data["state"];
            this.prescription = _data["prescription"] ? PrescriptionResponse.fromJS(_data["prescription"]) : new PrescriptionResponse();
        }
    }

    static fromJS(data: any): PrescriptionInventoryItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionInventoryItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryItemId"] = this.inventoryItemId;
        data["prescriptionType"] = this.prescriptionType;
        data["reservedQuantity"] = this.reservedQuantity;
        data["usedQuantity"] = this.usedQuantity;
        data["state"] = this.state;
        data["prescription"] = this.prescription ? this.prescription.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPrescriptionInventoryItemResponse {
    inventoryItemId: string;
    prescriptionType: PrescriptionTypeResponse;
    reservedQuantity: number;
    usedQuantity: number;
    state: InventoryItemState;
    prescription: PrescriptionResponse;
}

export enum PrescriptionTypeResponse {
    Undefined = "Undefined",
    Pn = "Pn",
    NotDispensed = "NotDispensed",
}

export enum InventoryItemState {
    Ready = "Ready",
    ReservedQuantityError = "ReservedQuantityError",
}

export class PrescriptionResponse implements IPrescriptionResponse {
    id!: string;
    drugName!: string;
    form!: string;
    strength!: string;
    dosageUnit!: string;
    state!: PrescriptionState;

    constructor(data?: IPrescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugName = _data["drugName"];
            this.form = _data["form"];
            this.strength = _data["strength"];
            this.dosageUnit = _data["dosageUnit"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): PrescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugName"] = this.drugName;
        data["form"] = this.form;
        data["strength"] = this.strength;
        data["dosageUnit"] = this.dosageUnit;
        data["state"] = this.state;
        return data; 
    }
}

export interface IPrescriptionResponse {
    id: string;
    drugName: string;
    form: string;
    strength: string;
    dosageUnit: string;
    state: PrescriptionState;
}

export class PrescriptionInventoryItemHistoryEntryResponse implements IPrescriptionInventoryItemHistoryEntryResponse {
    timestamp!: moment.Moment;
    executingEmployeeId!: string;
    reservedQuantity!: number;

    constructor(data?: IPrescriptionInventoryItemHistoryEntryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.executingEmployeeId = _data["executingEmployeeId"];
            this.reservedQuantity = _data["reservedQuantity"];
        }
    }

    static fromJS(data: any): PrescriptionInventoryItemHistoryEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionInventoryItemHistoryEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["executingEmployeeId"] = this.executingEmployeeId;
        data["reservedQuantity"] = this.reservedQuantity;
        return data; 
    }
}

export interface IPrescriptionInventoryItemHistoryEntryResponse {
    timestamp: moment.Moment;
    executingEmployeeId: string;
    reservedQuantity: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}